import React, { Component } from 'react';
import { Column, Table } from 'react-virtualized';
import InfiniteList from './InfiniteList';
import _ from 'lodash';
import Api from './Config';
import BooleanAlert from './BooleanAlert';
import Alert from './Alert';

export default class RegisterDoctor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doctorOffices: [],
      sortOrder: '',
      sortDirection: '',
      reloadList: 0,
    };

    this.loadRows = this.loadRows.bind(this);
    this.getTableCell = this.getTableCell.bind(this);
    this.headerRenderer = this.headerRenderer.bind(this);
  }

  async loadRows(startIdx, queryAmount) {
    const archived = this.props.mode == 'ARCHIVED' ? 'Y' : 'N';

    const results = await Api.getAllDoctors(
      archived,
      startIdx,
      queryAmount,
      this.state.sortOrder,
      this.state.sortDirection
    );

    let offices = results.data;
    if (startIdx > 0) {
      offices = this.state.doctorOffices.concat(offices);
    }
    this.setState({ doctorOffices: offices });

    return {
      data: results.data,
      maxRows: results.maxRows,
    };
  }

  doDelete(doc) {
    this.booleanAlert.open('Confirm', `Are you sure you want to archive ${doc.username}?`, () => {
      Api.deleteDoctor(doc.id)
        .then((resp) => {
          if (resp.SUCCESS == 'YES') {
            this.setState({ doctorOffices: this.state.doctorOffices.filter((item) => item.id != doc.id) });
            this.alert.open('Deleted', 'Provider Archived!');
          } else {
            this.alert.open('Error', resp.REASON);
          }
        })
        .catch((err) => {
          this.alert.open('ERR', `${err}`);
        });
    });
  }

  headerRenderer({ dataKey, label }) {
    return (
      <span
        className="text-primary"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          let newDir = 'asc';
          if (dataKey === this.state.sortOrder) {
            newDir = this.state.sortDirection == 'asc' ? 'desc' : 'asc';
          }

          this.setState({ sortOrder: dataKey, sortDirection: newDir, reloadList: this.state.reloadList + 1 });
        }}
      >
        {label}
      </span>
    );
  }

  getTableCell({ cellData, dataKey, rowData, rowIndex }) {
    let cellItem;

    switch (dataKey) {
      case 'row_idx':
        cellItem = rowIndex + 1;
        break;
      case 'clubname':
        cellItem = unescape(cellData);
        break;
      case 'actions':
        if (this.props.mode != 'ARCHIVED') {
          cellItem = (
            <React.Fragment>
              <button
                style={{ marginRight: 20 }}
                onClick={() => {
                  this.props.history.push(`/editDoctor/${rowData.id}`);
                }}
                className="btn btn-primary btn-sm"
              >
                Edit
              </button>
              <button
                onClick={() => {
                  this.doDelete(rowData);
                }}
                className="btn btn-danger btn-sm"
              >
                Archive
              </button>
            </React.Fragment>
          );
        }
        break;
    }

    return cellItem;
  }

  render() {
    return (
      <div>
        <InfiniteList lists={this.state.doctorOffices} loadRows={this.loadRows} reloadList={this.state.reloadList}>
          {({ onRowsRendered, registerChild, width }) => (
            <Table
              ref={registerChild}
              onRowsRendered={onRowsRendered}
              width={width}
              height={800}
              headerHeight={40}
              rowStyle={{
                borderBottom: '1px solid #ddd',
                paddingTop: 8,
                paddingBottom: 8,
              }}
              rowHeight={50}
              rowCount={this.state.doctorOffices.length}
              rowGetter={({ index }) => this.state.doctorOffices[index]}
            >
              <Column label="#" dataKey="row_idx" cellRenderer={this.getTableCell} width={width / 18} />
              <Column
                label="App Name"
                dataKey="clubname"
                cellRenderer={this.getTableCell}
                headerRenderer={this.headerRenderer}
                width={width / 2}
              />
              <Column label="App Id" dataKey="app_code" headerRenderer={this.headerRenderer} width={width / 7} />
              <Column label="OfcName" dataKey="username" headerRenderer={this.headerRenderer} width={width / 4} />
              <Column label="Remark" dataKey="remark" width={this.props.mode != 'ARCHIVED' ? width / 4 : width / 3} />
              <Column
                label=""
                dataKey="actions"
                cellRenderer={this.getTableCell}
                width={this.props.mode != 'ARCHIVED' ? 200 : 0}
              />
            </Table>
          )}
        </InfiniteList>
        <BooleanAlert
          ref={(ref) => {
            this.booleanAlert = ref;
          }}
        />
        <Alert
          ref={(a) => {
            this.alert = a;
          }}
        />
      </div>
    );
  }
}
